define([
    "./kpiConfigurationsController",
    "./kpiConfigurationsModule",
    "./kpiConfigurationsRouter",
    "./kpiConfigurationsService"
], function () {
});
